export interface CategoryTheme {
  accent: string;
  accentSoft: string;
  gradient: string;
}

export const CATEGORY_THEMES: Record<string, CategoryTheme> = {
  "cat-wellness": {
    accent: "#27AE60",
    accentSoft: "#E8F8EF",
    gradient: "linear-gradient(135deg, #27AE60 0%, #2ECC71 100%)",
  },
  "cat-fitness": {
    accent: "#576CEF",
    accentSoft: "#EEF0FF",
    gradient: "linear-gradient(135deg, #576CEF 0%, #7B93FF 100%)",
  },
  "cat-telehealth": {
    accent: "#2166AA",
    accentSoft: "#E8F2FA",
    gradient: "linear-gradient(135deg, #2166AA 0%, #3A8FD4 100%)",
  },
  "cat-vehicle-care": {
    accent: "#FC6509",
    accentSoft: "#FFF3EB",
    gradient: "linear-gradient(135deg, #FC6509 0%, #FF8A3D 100%)",
  },
  "cat-mental-health": {
    accent: "#9B59B6",
    accentSoft: "#F5EEFC",
    gradient: "linear-gradient(135deg, #9B59B6 0%, #BB7ACC 100%)",
  },
  "cat-nutrition": {
    accent: "#16A085",
    accentSoft: "#E8F6F3",
    gradient: "linear-gradient(135deg, #16A085 0%, #1ABC9C 100%)",
  },
  "cat-dental": {
    accent: "#3498DB",
    accentSoft: "#EBF5FB",
    gradient: "linear-gradient(135deg, #3498DB 0%, #5DADE2 100%)",
  },
  "cat-vision": {
    accent: "#1ABC9C",
    accentSoft: "#E8F8F5",
    gradient: "linear-gradient(135deg, #1ABC9C 0%, #48C9B0 100%)",
  },
  "cat-financial": {
    accent: "#F39C12",
    accentSoft: "#FEF5E7",
    gradient: "linear-gradient(135deg, #F39C12 0%, #F5B041 100%)",
  },
  "cat-legal": {
    accent: "#34495E",
    accentSoft: "#EAECEE",
    gradient: "linear-gradient(135deg, #34495E 0%, #5D6D7E 100%)",
  },
  "cat-child-eldercare": {
    accent: "#E45C8B",
    accentSoft: "#FDEEF4",
    gradient: "linear-gradient(135deg, #E45C8B 0%, #F07AA3 100%)",
  },
  "cat-pet-care": {
    accent: "#E67E22",
    accentSoft: "#FDF2E9",
    gradient: "linear-gradient(135deg, #E67E22 0%, #F39C12 100%)",
  },
};

export const DEFAULT_CATEGORY_THEME: CategoryTheme = {
  accent: "#2166AA",
  accentSoft: "#E8F2FA",
  gradient: "linear-gradient(135deg, #2166AA 0%, #3A8FD4 100%)",
};

export function getCategoryTheme(categoryId: string): CategoryTheme {
  return CATEGORY_THEMES[categoryId] ?? DEFAULT_CATEGORY_THEME;
}
